<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="weeklyRankRewards-tableSec">
            <div class="weeklyRankRewards-HD">Weekly Ranking Rewards</div>
            <div class="weeklyRankRewards-tableWrap">
                <table>
                    <tbody>
                        <tr v-for="reward in WeeklyRankRewardsRichData" :key="reward.id">
                            <td>Top {{ reward.rank }}</td>
                            <td><span><img :src='diamondIcon' class="diamondIcon" alt="" /></span> {{ reward.reward_coin
                                }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="rankingRewards-ruleCont">
            <ul>
                <li>Rich ranking is based on the Diamonds that the user has consumed.</li>
                <li>He ranking update time is subject to GMT + 5:30.</li>
                <li>The rearwards of weekly will be distributed on every Monday.</li>
                <li>The Diamonds of lucky gifts aren’t calculated. (comment)</li>
            </ul>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import diamondIcon from '../../assets/images/diamond-icon.png'
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'weeklyRankRewardsRich',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            WeeklyRankRewardsRichData: [],
            diamondIcon: diamondIcon,
            loading: false
        }
    },
    mounted() {
        this.fetchWeeklyRankRewardsRichData();
    },
    methods: {
        fetchWeeklyRankRewardsRichData() {
            this.loading= true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            const apiUrl = `api/top-rich-weekly?type=this_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.WeeklyRankRewardsRichData = response.data.result.weeklyrewards;
                })

                .catch(error => {
                    console.error("Error Featching Weekly Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
    },
}
</script>